import React, { useState } from "react";
import styles from "./AllChatsContainer.module.scss";
import UsersIcon from "../../assets/icons/UsersIcon";
import { SelectedChatContainer } from "../SelectedChatContainer/SelectedChatContainer";
import { useDispatch, useSelector } from "react-redux";
import {
  getAvitoChatHistory,
  getInstagramChatHistory,
  getTelegramChatHistory,
  getVkChatHistory,
  getWhatsappChatHistory,
} from "../../utils/api/actions/dialogs";
import { clearActiveDialogs } from "../../store/slices/dialogSlice";
import { useLocation } from "react-router-dom";

export const AllChatsContainer = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const getIntegrationType = () => {
    const pathSegments = location.pathname.split("/"); // Разделяем путь на сегменты
    return pathSegments[2]; // Берем третий сегмент (индекс 2)
  };

  const integrationType = getIntegrationType();

  const { activeTg, activeWa, activeInst } = useSelector(
    (state) => state?.integration
  );
  const { activeAvito } = useSelector((state) => state?.avito);
  const { activeVk } = useSelector((state) => state?.vk);
  const { activeDataBitrixChatBot } = useSelector(
    (state) => state?.bitrixChatBot
  );

  const [openChat, setOpenChat] = useState(false);
  const [selectedChatTitle, setSelectedChatTitle] = useState("");
  const [itemUrl, setItemUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const handleOpenChat = (dialogId, chatTitle, itemUrl) => {
    if (activeTg) {
      dispatch(clearActiveDialogs());
      dispatch(getTelegramChatHistory(dialogId, setLoading));
    } else if (activeWa) {
      dispatch(clearActiveDialogs());
      dispatch(getWhatsappChatHistory(dialogId, setLoading));
    } else if (activeInst) {
      dispatch(clearActiveDialogs());
      dispatch(getInstagramChatHistory(dialogId, setLoading));
    } else if (activeAvito) {
      dispatch(clearActiveDialogs());
      dispatch(getAvitoChatHistory(dialogId, setLoading));
    } else if (activeVk) {
      dispatch(clearActiveDialogs());
      dispatch(getVkChatHistory(dialogId, setLoading));
    } else if (activeDataBitrixChatBot) {
      dispatch(clearActiveDialogs());
      console.log("get bitrix chat bot history");
    }

    setOpenChat(true);
    setSelectedChatTitle(chatTitle);
    setItemUrl(itemUrl);
  };

  const ChatCard = ({ item }) => {
    const fullNameUserVk = `${item?.partnerFirstName} ${item.partnerLastName}`;
    return (
      <div
        className={styles.chatCard}
        onClick={() =>
          handleOpenChat(
            item.dialogId,
            item.chatTitle || item.partnerName || fullNameUserVk,
            item.itemUrl
              ? item.itemUrl
              : item.partnerProfileUrl
              ? item.partnerProfileUrl
              : null
          )
        }
        key={item.chatId}
      >
        <div className={styles.infoContainer}>
          <div className={styles.chatTitle}>
            {item.chatTitle ||
              item.chatTitle ||
              item.partnerName ||
              fullNameUserVk}
          </div>
          {integrationType === "telegram" && (
            <div className={styles.chatUserName}>@{item.partnerUserName}</div>
          )}

          {integrationType === "vk" && (
            <div className={styles.chatUserName}>{item.partnerScreenName}</div>
          )}

          {integrationType === "avito" && (
            <div className={styles.chatUserName}>
              {item.chatType === "u2i" && "По объявлению"}
            </div>
          )}

          {integrationType === "bitrix-chat-bot" && (
            <div className={styles.chatUserName}>{item.partnerScreenName}</div>
          )}

          <div className={styles.chatPhoneNumber}>
            {item.partnerPhoneNumber
              ? item.partnerPhoneNumber
              : item.partnerPhone
              ? item.partnerPhone
              : item.partnerId}
          </div>
        </div>
        <UsersIcon />
      </div>
    );
  };

  const NoChatsContainer = () => {
    return (
      <div className={styles.noActiveChatContainer}>
        <div className={styles.noActiveChatContainerTitle}>
          У вас еще нет активных чатов
        </div>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      {openChat ? (
        <SelectedChatContainer
          handleGoBack={() => setOpenChat(false)}
          name={selectedChatTitle}
          loading={loading}
          itemUrl={itemUrl}
        />
      ) : integrationType === "telegram" && activeTg?.chats ? (
        activeTg.chats.map((item, index) => {
          return <ChatCard item={item} />;
        })
      ) : integrationType === "whatsapp" && activeWa?.chats ? (
        activeWa.chats.map((item, index) => {
          return <ChatCard item={item} />;
        })
      ) : integrationType === "instagram" && activeInst?.chats ? (
        activeInst.chats.map((item, index) => {
          return <ChatCard item={item} />;
        })
      ) : integrationType === "avito" && activeAvito?.chats ? (
        activeAvito.chats.map((item, index) => {
          return <ChatCard item={item} />;
        })
      ) : integrationType === "vk" && activeVk?.chats ? (
        activeVk.chats.map((item, index) => {
          return <ChatCard item={item} />;
        })
      ) : integrationType === "bitrix-chat-bot" &&
        activeDataBitrixChatBot?.chats ? (
        activeDataBitrixChatBot.chats.map((item, index) => {
          return <ChatCard item={item} />;
        })
      ) : (
        <NoChatsContainer />
      )}
    </div>
  );
};
